export default "__VITE_ASSET__92e89ec1__"